import { defineView } from "@/ReactSetup/view-definitions";

const definition = defineView({
    name: "ArticleIntro",
    component: () => (__SERVER__ ? require("./article-intro-view") : import("./article-intro-view"))
});

export default definition;
